import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import Link from '@material-ui/core/Link';

const P = styled.p`
  margin: 0;
`;

interface Props {}
const ErrorComponent: VFC<Props> = (props: Props) => (
  <P>
    {T.translate('homes.instagram.failFetchImage', {
      link: (
        <Link
          href={process.env.OFFICIAL_INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
        >
          {T.translate('homes.instagram.otetsutabiOfficialInstagram')}
        </Link>
      ),
    })}
  </P>
);

export default ErrorComponent;
